import get from '@invitato/helpers/dist/getLocale';

export default {
  lovestory: get('Perjalanan Cinta Kami', 'Our Story'),
  textDear: get('Kepada Bapak/Ibu/Saudara/i,', 'Dear Mr/Mrs/Ms,'),
  guest: get('Keluarga & Teman-teman', 'Family & Friends'),
};
